/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiRerunScenariosForPersonsByIdsRequest
 */
export interface InternalApiRerunScenariosForPersonsByIdsRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiRerunScenariosForPersonsByIdsRequest
     */
    scenarioHandles: Array<string>;
    /**
     * 
     * @type {Array<number>}
     * @memberof InternalApiRerunScenariosForPersonsByIdsRequest
     */
    personIds: Array<number>;
}

/**
 * Check if a given object implements the InternalApiRerunScenariosForPersonsByIdsRequest interface.
 */
export function instanceOfInternalApiRerunScenariosForPersonsByIdsRequest(value: object): value is InternalApiRerunScenariosForPersonsByIdsRequest {
    if (!('scenarioHandles' in value) || value['scenarioHandles'] === undefined) return false;
    if (!('personIds' in value) || value['personIds'] === undefined) return false;
    return true;
}

export function InternalApiRerunScenariosForPersonsByIdsRequestFromJSON(json: any): InternalApiRerunScenariosForPersonsByIdsRequest {
    return InternalApiRerunScenariosForPersonsByIdsRequestFromJSONTyped(json, false);
}

export function InternalApiRerunScenariosForPersonsByIdsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRerunScenariosForPersonsByIdsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scenarioHandles': json['scenarioHandles'],
        'personIds': json['personIds'],
    };
}

export function InternalApiRerunScenariosForPersonsByIdsRequestToJSON(json: any): InternalApiRerunScenariosForPersonsByIdsRequest {
    return InternalApiRerunScenariosForPersonsByIdsRequestToJSONTyped(json, false);
}

export function InternalApiRerunScenariosForPersonsByIdsRequestToJSONTyped(value?: InternalApiRerunScenariosForPersonsByIdsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scenarioHandles': value['scenarioHandles'],
        'personIds': value['personIds'],
    };
}

